import { ResourceLookUpConstants } from '../constants';
export const RESOURCE_LOOKUP_GET_RESOURCES = `${ResourceLookUpConstants.MODULE_PREFIX}_GET_RESOURCES`;
export const RESOURCE_LOOKUP_GET_RESOURCES_SUCCESS = `${ResourceLookUpConstants.MODULE_PREFIX}_GET_RESOURCES_SUCCESS`;
export const RESOURCE_LOOKUP_GET_RESOURCES_FAILURE = `${ResourceLookUpConstants.MODULE_PREFIX}_GET_RESOURCES_FAILURE`;
export const RESOURCE_LOOKUP_RESET_RESOURCE_LOOKUP = `${ResourceLookUpConstants.MODULE_PREFIX}_RESET_RESOURCE_LOOKUP`;
export const getResourcesAction = (resourceLookupPayload) => ({
    type: RESOURCE_LOOKUP_GET_RESOURCES,
    payload: resourceLookupPayload
});
export const getResourcesSuccessAction = (resources) => ({
    type: RESOURCE_LOOKUP_GET_RESOURCES_SUCCESS,
    payload: resources
});
export const getResourcesFailureAction = (failureMessage) => ({
    type: RESOURCE_LOOKUP_GET_RESOURCES_FAILURE,
    payload: { failureMessage }
});
export const resetResourceLookupStateAction = () => ({
    type: RESOURCE_LOOKUP_RESET_RESOURCE_LOOKUP,
    payload: null
});
//# sourceMappingURL=resourceLookupActions.js.map